const MISC_CONST = {
    lOADER_STATE: "lOADER_STATE",
    ERROR_MSG: "SET_ERROR_MESSAGE",
    SUCCESS_MSG: "SET_SUCCESS_MESSAGE",
    LOGIN_FROM_CHECKOUT: "LOGIN_FROM_CHECKOUT",
    FOOTER_DISPLAY_STATUS: "SET_FOOTER_DISPLAY"
}
export default MISC_CONST;